<template>
  <RouterView />
  <DevTool class="fixed left-1 top-1 rounded-sm opacity-50" />
  <ModalDialog />
</template>

<script setup>
import DevTool from './components/DevTool.vue';
import ModalDialog from './components/ModalDialog.vue';
</script>
